export default __webpack_public_path__ + "static/media/tour.7d5ba4d7.svg";